var React = require('react');
 import {CreateEntertainer } from '../actions/LoginServiceCreator';
import Facebook from './Facebook';
var cookie = require('react-cookie');

class entertainer extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  }

  render() {
    if (cookie.load('logged_in') === 1) {
      window.location.href = '/';
      return;
    }
    return (
      <div>
        <div className="container_fluid main_container second-section login-container" id="content">
          <div className="row-fluid clearfix login-innercontainer">
            <div className="logged-container">
              <div className="signup-content">
                <div className="login-types">
                  <div className="login-title">
                    Entertainer Signup
                  </div>
                  <div className="social-signup">
                    <form method="post" className="signup-form" name="signup-form">
                      {/*<div className="signup-title">
                        <span>Email:</span>
                        <input type="email" required pattern="/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/" width="100" name="email" className="formEmail"
                        />
                        <div id="email-err" className="signup-error"></div>
                        </div>
                        <div className="signup-title">
                          <span>Name:</span>
                          <input type="text" required pattern="\w+" width="100" name="username" className="formUname" />
                          <div id="user-err" className="signup-error"></div>
                      </div>*/}
                      <div className="signup-title">
                        <span>Age:</span>
                        <input type="text" required pattern="\w+" width="100" name="age" className="formUage" />
                        <div id="age-err" className="signup-error"></div>
                      </div>
                      <div className="signup-title">
                        <span>Gender:</span>
                        <select id="formUgender">
                        <option value="select">select</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </select>
                        <div id="gender-err" className="signup-error"></div>
                      </div>
                      <div className="signup-title">
                        <span>Nationality:</span>
                          <select id="formUnationality" onfocus='this.size=5;'onblur='this.size=1;' onchange='this.size=1; this.blur();'>
                          <option value="select">select</option><option value="LB">LB</option><option value="SA">SA</option><option value="IR">IR</option><option value="ZA">ZA</option><option value="AE">AE</option><option value="QA">QA</option><option value="JO">JO</option><option value="OM">OM</option><option value="EG">EG</option><option value="PH">PH</option><option value="PE">PE</option><option value="MT">MT</option><option value="CN">CN</option><option value="GB">GB</option><option value="IN">IN</option><option value="GR">GR</option><option value="IQ">IQ</option><option value="AR">AR</option><option value="AF">AF</option><option value="BV">BV</option><option value="AM">AM</option><option value="AU">AU</option><option value="SY">SY</option><option value="KR">KR</option><option value="HK">HK</option><option value="SE">SE</option><option value="MA">MA</option><option value="CA">CA</option><option value="CL">CL</option><option value="IT">IT</option><option value="FR">FR</option><option value="PK">PK</option><option value="CH">CH</option><option value="US">US</option><option value="CY">CY</option><option value="LU">LU</option><option value="NZ">NZ</option><option value="PS">PS</option><option value="MN">MN</option><option value="UZ">UZ</option><option value="IE">IE</option><option value="ET">ET</option><option value="KZ">KZ</option><option value="ES">ES</option><option value="BH">BH</option><option value="BY">BY</option><option value="DE">DE</option><option value="LK">LK</option><option value="CC">CC</option><option value="UA">UA</option><option value="TR">TR</option><option value="KM">KM</option><option value="NL">NL</option><option value="DZ">DZ</option><option value="JP">JP</option><option value="CO">CO</option><option value="RU">RU</option><option value="KN">KN</option><option value="AS">AS</option><option value="YE">YE</option><option value="SD">SD</option><option value="DK">DK</option><option value="BD">BD</option><option value="FI">FI</option><option value="HU">HU</option><option value="MZ">MZ</option><option value="IS">IS</option><option value="HR">HR</option><option value="AT">AT</option><option value="TM">TM</option><option value="KW">KW</option><option value="TN">TN</option><option value="PY">PY</option><option value="BE">BE</option><option value="MY">MY</option><option value="BR">BR</option><option value="ID">ID</option><option value="ZW">ZW</option><option value="SG">SG</option><option value="PT">PT</option><option value="CM">CM</option><option value="PL">PL</option><option value="NO">NO</option><option value="CZ">CZ</option><option value="TZ">TZ</option><option value="MU">MU</option><option value="SK">SK</option><option value="AZ">AZ</option><option value="AW">AW</option><option value="MK">MK</option><option value="VN">VN</option><option value="MD">MD</option><option value="RO">RO</option><option value="AG">AG</option><option value="IM">IM</option><option value="AL">AL</option><option value="LV">LV</option><option value="KE">KE</option><option value="RS">RS</option><option value="NG">NG</option><option value="IO">IO</option><option value="UM">UM</option><option value="BL">BL</option><option value="BA">BA</option><option value="TJ">TJ</option><option value="LT">LT</option><option value="AQ">AQ</option><option value="VE">VE</option><option value="AX">AX</option><option value="AD">AD</option><option value="TW">TW</option><option value="BN">BN</option><option value="EE">EE</option><option value="PA">PA</option><option value="KG">KG</option><option value="BZ">BZ</option><option value="MX">MX</option><option value="AI">AI</option><option value="LI">LI</option><option value="GG">GG</option><option value="SN">SN</option><option value="CU">CU</option><option value="DO">DO</option><option value="BG">BG</option><option value="GE">GE</option><option value="EC">EC</option><option value="MM">MM</option><option value="BT">BT</option><option value="CR">CR</option><option value="LY">LY</option><option value="BQ">BQ</option><option value="GW">GW</option><option value="MP">MP</option><option value="BW">BW</option><option value="KP">KP</option><option value="NC">NC</option><option value="BF">BF</option><option value="UG">UG</option><option value="DM">DM</option><option value="BO">BO</option><option value="SC">SC</option><option value="MW">MW</option><option value="TH">TH</option><option value="SZ">SZ</option><option value="FK">FK</option><option value="NP">NP</option><option value="SI">SI</option><option value="AO">AO</option><option value="GH">GH</option><option value="SO">SO</option><option value="LR">LR</option><option value="NI">NI</option><option value="JM">JM</option><option value="ME">ME</option><option value="SV">SV</option><option value="TF">TF</option><option value="BB">BB</option><option value="ER">ER</option><option value="EH">EH</option><option value="NA">NA</option><option value="VU">VU</option><option value="GD">GD</option><option value="CI">CI</option><option value="TT">TT</option><option value="UY">UY</option><option value="JE">JE</option><option value="VG">VG</option><option value="DJ">DJ</option><option value="BJ">BJ</option><option value="GT">GT</option><option value="BM">BM</option><option value="MG">MG</option><option value="SS">SS</option><option value="FJ">FJ</option><option value="LA">LA</option><option value="TV">TV</option><option value="ZM">ZM</option><option value="GA">GA</option>
                          </select>

                        <div id="nationality-err" className="signup-error"></div>
                      </div>
                      <div className="signup-title">
                        <a href="/"><span className="cancel-btn">Cancel</span></a>
                        <div className="complete" onClick={ this.submit.bind(this) }><span className="complete-tick">✔</span><span className="complete-btn">Submit</span></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }
  submit() {

    // var email = $(".formEmail").val();
    // var username = $(".formUname").val();
    var email = "newuserWithoutEmail";
    var username = "newuserWithoutName";
    var age = $(".formUage").val();
    var gender = $("#formUgender option:selected").text();
    var nationality = $("#formUnationality option:selected").text();

    var re = "";

    // re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    // if (email == "") {
    //   $('#email-err').text("Error: email cannot be blank!");
    //   $(".formEmail").focus();
    //   return false;
    // } else if (!re.test(email)) {
    //   $('#email-err').text("Error: enter valid email id");
    //   $(".formEmail").focus();
    //   return false;
    // } else {
    //   $('#email-err').text("");
    // }
    //
    // re = /[^a-zA-Z0-9]/;
    // if (username == "") {
    //   $('#user-err').text("Error: Username cannot be blank!");
    //   $(".formUname").focus();
    //   return false;
    // } else {
    //   $('#user-err').text("");
    // }


    function isInteger(x) {
      return x % 1 === 0;
    }
    isInteger(age);
    if(age == ""){
      $('#age-err').text("Error: email cannot be blank!");
      $(".formUage").focus();
      return false;
    }else if(!isInteger(age)){
      $('#age-err').text("Error: enter valid age!");
      $(".formUage").focus();
      return false;
    }else{
      $('#age-err').text("");
    }

    if(gender == 'select'){
      $('#gender-err').text("Error: select ur gender");
      return false;
    }else{
      $('#gender-err').text("");
    }

    if(nationality == 'select'){
      $('#nationality-err').text("Error: select ur nationality");
      return false;
    }else{
      $('#nationality-err').text("");
    }

    //cookie.load()
    var id = Math.random().toString(36).slice(2);

    var formValues = {
        email,
        username,
        age,
        gender,
        nationality,
        id
    };
    var date = new Date();
      var days = days || 365;
      date.setTime(+date + (days * 86400000));
      cookie.save('Entertainer', formValues, {
        expires: date,
        httpOnly: false,
        path: '/'
      });
      cookie.save('sid', Math.random().toString(36).slice(2), {
        expires: date,
        httpOnly: false,
        path: '/'
      });
      //cookie.save('sid',)
    $(".whirly-loader").css('visibility', 'visible');
    this.context.executeAction(CreateEntertainer, formValues);

  }
}

module.exports = entertainer;



// WEBPACK FOOTER //
// ./src/components/Entertainer.js